export default __webpack_public_path__ + "static/media/bra-arte-2.6b7820fd.webp";